export default {
  title: 'Accesos directos',
  links: {
    reservations: 'Reservas',
    orders_portal: 'Acceso terminal',
    closed: '¿Cerrado?',
    menu: 'Cambiar menú',
    payouts: 'Informes de pagos',
    opening_hours: 'Horario de apertura',
  },
};
